import { _ } from "libs";

import React, { useEffect, useState } from "react";
import ClubsList from "./clubsList";
import { getRecentClubs } from "../actions";
import { Club } from "../types";

const RecentClubs = () => {
	const [clubs, setClubs] = useState([]);

	useEffect(() => {
		let unmounted = false;

		getRecentClubs().then((clubResult: Club[]) => {
			let clubs = {};

			for (let club of clubResult) {
				if (!clubs.hasOwnProperty(club.clubInfo.clubId)) {
					clubs[club.clubInfo.clubId] = club;
				}
			}
			if (!unmounted) {
				setClubs(Object.values(clubs));
			}
		});

		return () => {
			unmounted = true;
		};
	}, []);

	return (
		<div className="dBlock">
			<h5>{_("recentClubsWidget.heading")}</h5>
			<ClubsList clubs={clubs} />
		</div>
	);
};

export default RecentClubs;
